// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[data-v-1e4b0734] .page {\n  padding-bottom: 36px;\n}\n", ""]);
// Exports
module.exports = exports;
